import {ShiftReportColumn} from '../../../shift-report/ShiftReportColumn';

export class ShiftReportTableSettingsDialogData {
  columns: ShiftReportColumn[];

  constructor(columns: ShiftReportColumn[]) {
    this.columns = columns;
  }
}
